import * as z from "zod";

export const getParcelPackingSlip = {
  name: "getParcelPackingSlip" as const,
  input: z.object({
    fulfillmentGroupId: z.string(),
    parcelIndex: z.number().int().nonnegative(),
  }),
  output: z.object({ url: z.string() }),
};
